import { render, staticRenderFns } from "./TbFilaDetail.vue?vue&type=template&id=be474b36&scoped=true"
import script from "./TbFilaDetail.vue?vue&type=script&lang=js"
export * from "./TbFilaDetail.vue?vue&type=script&lang=js"
import style0 from "./TbFilaDetail.vue?vue&type=style&index=0&id=be474b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be474b36",
  null
  
)

export default component.exports